import Footer from "../../../navigation/footerContainer";
import UpdateDetailContainer from "./updateDetailContainer";

export default function UpdateDetailPage(){
    return(
        <>
            <UpdateDetailContainer />
            <Footer />
        </>

    )
}